import React, { Component } from 'react';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import { callApi } from '../../../util/ApiUtil';
import config from '../../../config/config';
import REST_API_NAMES from '../../../config/restApiNames';
import analyticsContext from '../../analytics/Analytics';
import { applyRequiredCapitalizations } from '../../../util/TextUtils';
import { theme } from '../../../../../themes';
import QuotesData from './Quotes.data';
import partnerStyles from '../../../config/partnerStylesConfig';

class Quotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topic: '',
      topicShown: false,
      learnContainerStyle: partnerStyles.learnContainerStyle,
    };

    this.handleChange = this.handleChange.bind(this);
    this.modalShownState = this.modalShownState.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      topic: event.target.value,
    });
  }

  modalShownState() {
    this.setState({
      topicShown: !this.state.topicShown,
    });
  }

  handleSubmit() {
    this.setState({
      topicShown: !this.state.topicShown,
      topic: '',
    });
    this.sendTopic();
  }
  sendTopic() {
    analyticsContext
      .withAdvancedProps({
        type: 'survey',
        name: 'suggest_topic',
        value: this.state.topic,
      })
      .controlEvent();
    callApi({
      method: 'POST',
      url: config.REST_URL(REST_API_NAMES.survey),
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ topic: this.state.topic }),
    });
  }

  render() {
    return (
      <div className="quotesComponent">
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={7}>
              <div
                className="quotesContainer"
                style={{
                  backgroundColor: theme.colors.featureSection2,
                  color: theme.colors.featureSection2FontColor,
                }}
              >
                <div className="quote tertiaryHeadingFonts">{QuotesData.quote}</div>
                <div className="quoteExpert">
                  <div className="quoteExpert__figure">
                    <img src={QuotesData.photo} className="quoteExpert__img" />
                  </div>
                  <div className="quoteExpert__info">
                    <div className="quoteExpert__info--name tertiaryHeadingFonts">{QuotesData.name}</div>
                    <div className="quoteExpert__info--position bodyTextFonts">{QuotesData.jobTitle}</div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={5}>
              <div className="learnContainer" style={this.state.learnContainerStyle}>
                <div className="learn">
                  <h2 className="learn__title secondaryHeaderFonts">Want to learn more?</h2>
                  <div className="learn__text bodyTextFonts">
                    If you still need help or want to explore a tech topic we haven’t covered, let us know.
                  </div>
                  <a onClick={this.modalShownState} className="learn__btn btn">
                    {applyRequiredCapitalizations('Suggest a topic')}
                  </a>
                </div>
                {this.state.topicShown && (
                  <form onSubmit={this.handleSubmit} className="formContainer">
                    <div className="topic">
                      <p className="topic__text">What would you like to learn?</p>
                      <textarea
                        className="topic__input"
                        name="topic"
                        id="topic"
                        value={this.state.topic}
                        onChange={this.handleChange}
                        placeholder="Enter the topic description"
                      />
                      <div className="formBtn">
                        <input
                          type="submit"
                          value="Submit"
                          className="btn inGreen topic__btn"
                          style={{
                            backgroundColor:
                              theme.colors.experiencesPrimaryButtonBackground || theme.colors.primaryAccent,
                            border:
                              theme.colors.experiencesPrimaryButtonTitle || `2px solid ${theme.colors.primaryAccent}`,
                            color: theme.colors.experiencesPrimaryButtonTitle || theme.colors.primaryAccentFontColor,
                          }}
                        />
                        <a onClick={this.modalShownState} className="learn__btn btn topic__btn">
                          Cancel
                        </a>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Quotes;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/Quotes/Quotes.js